const Dates = {
  defaultFormat: 'MM/DD/YYYY',
  defaultFormatWithTime: 'MM/DD/YYYY h:mm:ss A',
  apiDateFormat: 'YYYY-MM-DD',
  defaultTimeFormat: 'h:mm:ss A',
  extendedFormatWithTime: 'MMMM D, YYYY h:mm A',
};

export default Dates;
